// i18n area 'apps' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.cs-CZ.meta.json.
import type { enUS } from './apps'

export const csCZ: typeof enUS = {

  // Apps vlna 1 (Annex R): spravované podman kontejnery — dohlíží na ně
  // worker na deklarovaném uzlu; obraz = lockfile branch@digest (Annex Q)
  // s policy pinned/tracking; L3 untagged připojení se statickou IP.
  apps: {
    title: 'Aplikace',
    create: 'Vytvořit aplikaci',
    createTitle: 'Vytvořit aplikaci',
    editTitle: 'Upravit aplikaci',
    name: 'Název',
    nameHint: 'DNS-1123, jedinečný v rámci scopu — po vytvoření neměnný.',
    node: 'Uzel',
    nodeHint: 'Členský uzel, který ji obsluhuje — explicitní umístění (scheduler přijde později).',
    image: 'Obraz',
    editImageHint: 'Nový odkaz se znovu vyhodnotí přes evidenci — gesto pinu/rollbacku.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest se pohne jen na příkaz.',
    policyTrackingHint: 'Automatický rolling, když refresh posune branch.',
    archMovePolicy: 'Přesun cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Co se stane, když se app přesune na node jiné architektury: refuse přesun odmítne, reresolve znovu vyřeší lockfile z branche na nové arch — obsah se změní a odpověď pojmenuje změnu digestu.',
    network: 'Síť',
    networkHint: 'L3 untagged připojení: logická síť fabricu (doporučeno — gateway/DNS z jejího jediného zdroje), overlay, nebo holý hostitelský bridge (nedoporučeno).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'hostitelský bridge:',
    ipAssignment: 'Přidělení IP',
    ipStatic: 'Statické',
    ipAuto: 'Automatické (IPAM)',
    ipAssignmentHint_static: 'Adresu zadáte vy, teď.',
    ipAssignmentHint_auto: 'IPAM vybere volnou adresu z rozsahů sítě vyhrazených pro TVirt.',
    bridgeDiscouraged: 'Holý hostitelský bridge — NEDOPORUČENO: TVirt o jeho adresování nic neví, gateway a DNS je tedy nutné zadat ručně. Doporučená cesta je logická síť fabricu.',
    ip: 'IP',
    ipHint: 'Statická IPv4 uvnitř podsítě připojení.',
    ipCidrHint: 'Na holém bridgi ve tvaru CIDR (např. 192.168.1.10/24) — prefix není odkud odvodit.',
    gateway: 'Gateway',
    gatewayManualHint: 'Ručně — holý bridge nic neodvozuje.',
    dnsServers: 'Servery DNS',
    dnsManualHint: 'Ručně, oddělené čárkou — alespoň jeden.',
    rootKind: 'Root',
    rootEphemeral: 'efemérní',
    rootPersistent: 'perzistentní',
    rootEphemeralHint: 'Při každém znovuvytvoření vzniká znovu z obrazu; žije na efemérním úložišti klastru.',
    rootEphemeralHintNamed: 'Při každém znovuvytvoření vzniká znovu z obrazu; žije na efemérním úložišti klastru ({name}).',
    rootPersistentHint: 'Přežívá restarty; žije na úložišti, které zvolíte.',
    rootStorage: 'Úložiště rootu',
    editRootStorageHint: 'Root se znovu vyrenderuje na novém poolu — existující data se sama NEPŘESUNOU.',
    volumes: 'Svazky',
    volumeAdd: 'Přidat svazek',
    volumeName: 'Název',
    volumeMountPath: 'Přípojná cesta',
    volumeKind: 'Typ',
    volumeStorage: 'Úložiště',
    devices: 'Zařízení',
    deviceClassHint: 'Žádá se TŘÍDA (tag gpu-device nebo usb-device), nikdy konkrétní zařízení: deklarovaný uzel musí mít nějaké označené pro Apps. Několik Apps může používat totéž zařízení — kontejner ho sdílí, neodebírá ho hostiteli.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Třída',
    deviceUnresolved: 'teď se nic neřeší',
    noDeviceTags: 'Zatím žádný tag druhu gpu-device nebo usb-device: vytvořte jej a přiřaďte zařízením označeným pro Apps.',
    env: 'Prostředí',
    envHint: 'Jeden KLÍČ=hodnota na řádek.',
    secretEnvTitle: 'Tajné proměnné',
    secretEnvNotice: 'Tajná hodnota se z API už nikdy nevrátí: nikdo si ji znovu nepřečte, ani ten, kdo ji zapsal. V checkpointu cestuje zapečetěná masterpassem, takže obnovení bez masterpassu si ji vyžádá znovu.',
    secretEnvPromote: 'Označte jako tajnou jednu z proměnných zapsaných výše:',
    secretEnvAdd: 'Přidat tajnou proměnnou',
    secretEnvName: 'Název',
    secretEnvValue: 'Hodnota',
    secretEnvKept: 'zachována — nechte prázdné, aby zůstala beze změny',
    secretEnvWithdrawWarning: 'Chcete-li přestat zacházet jako s tajnou s proměnnou, která už tajná je, zapište jí novou hodnotu: samotné sejmutí značky by byl způsob, jak PŘEČÍST to, co store nikdy neopustí. Její odebrání ji naopak smaže.',
    secretEnvChip: 'tajné',
    startNow: 'Spustit hned (jinak se aplikace narodí zastavená)',
    deletePersistentIntro: 'Tato aplikace má perzistentní data — zvolte, co s nimi:',
    deleteKeepData: 'Ponechat data (adresáře zůstanou na svých úložištích, osiřelé)',
    deletePurgeData: 'Odstranit i data',
    phase: 'Fáze',
    phase_running: 'Běží',
    phase_stopped: 'Zastavená',
    phase_error: 'Chyba',
    phase_unknown: 'Neznámá',
    desiredState: 'Požadováno',
    wantedRunning: 'běžící',
    wantedStopped: 'zastavená',
    start: 'Spustit',
    stop: 'Zastavit',
    restart: 'Restartovat',
    refreshImage: 'Aktualizovat obraz (převzít nový @current)',
    logs: 'Logy',
    logsTitle: 'Logy',
    logsEmpty: 'Žádný zachycený výstup.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App neběží — shell potřebuje živý kontejner. Její logy lze číst v jakémkoli stavu.',
    shellConnect: 'Připojit',
    shellDisconnect: 'Odpojit',
    shellExited: 'Relace skončila s návratovým kódem {code}.',
    shellEndedWithoutStatus: 'Relace skončila bez návratového stavu: {reason}',
    shellRevoked: 'Ticket relace už není platný — vypršel, nebo přihlášení, které ho otevřelo, bylo odvoláno.',
    shellHint: 'Klikněte do černého pole a pište: klávesy jdou do kontejneru. Ctrl+C a šipky fungují; exit shell zavře.',
    shellStatus: {
      connecting: 'Připojování…',
      connected: 'Připojeno',
      ended: 'Ukončena'
    },
    deleteRunningError: '{name} má požadovaný stav „běžící" — nejdřív ji zastavte.',

    // Standardní dialog (round #156): karty detailu a chybějící pole
    // contractu — každé pole aplikace viditelné, zámky s vysvětlením proč.
    tabs: {
      general: 'Obecné',
      image: 'Obraz',
      network: 'Síť',
      storage: 'Úložiště',
      devices: 'Zařízení',
      observed: 'Pozorováno'
    },
    attachment: 'Připojení',
    runningDigest: 'Běžící digest',
    lastError: 'Poslední chyba',
    reportObservedAt: 'Poslední hlášení workeru',
    desiredStateLock: 'Řídí ho akce Spustit/Zastavit — nikdy přímá úprava.',
    ipEditDisabledHint: 'Upravitelné jen při statickém přidělení.',
    derivedFromNetworkHint: 'Odvozeno z jediného zdroje sítě — ručně jen na holém bridgi se statickou IP.',
    ephemeralUnset: 'nenastaveno',
    ephemeralMissing: 'Efemérní úložiště aplikací není nastaveno — vytvoření aplikace s efemérními částmi (root nebo svazky) bude odmítáno, dokud ho nenastavíte.',
    ephemeralCurrent: 'Efemérní úložiště aplikací: {name}',
    ephemeralMissingCreate: 'Tato aplikace má efemérní části, ale efemérní úložiště aplikací není nastaveno — vytvoření bude odmítnuto. Nejdřív ho nastavte z banneru na stránce Aplikace.',
    setEphemeral: 'Nastavit efemérní úložiště',
    changeEphemeral: 'Změnit efemérní úložiště',
    setEphemeralTitle: 'Nastavit efemérní úložiště aplikací',
    changeEphemeralTitle: 'Změnit efemérní úložiště aplikací',
    ephemeralStorageHint: 'DEFAULT klastru: dir-like pool, kde žijí rooty a efemérní svazky každé aplikace, pokud aplikace nedeklaruje override. Změna neproběhne za běhu a nic nerestartuje: platí od příštího startu každé aplikace — efemérní data se nepřesouvají.',
    ephemeralPool: 'Pool úložiště',
    ephemeralOverride: 'Efemérní úložiště (override pro aplikaci)',
    ephemeralOverrideInherit: 'Zdědit default klastru',
    ephemeralOverrideInheritNamed: 'Zdědit default klastru ({name})',
    ephemeralOverrideHint: 'Pool pro root a efemérní svazky této aplikace — nechte prázdné pro zdědění defaultu klastru. Změna neproběhne za běhu a nic nerestartuje: platí od příštího startu (efemérní data se znovu narodí prázdná na novém poolu) a vyžaduje oprávnění app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Všechny větve',
    imageBranchHint: 'Zúží obrazy na ty, které tato větev jmenuje; bez větve jsou vidět všechny obrazy repozitáře.',
    imageDigestHint: 'Obsah: vybírá se z tabulky digestů, která nese jeho původ i architekturu. Tatáž větev jich nabízí jeden na architekturu a nejsou zaměnitelné.',
    imageLockfile: 'Vyřešený odkaz',
    imageNoImages: 'Pro tento repozitář nejsou v cache žádné obrazy — stáhni jeden z Obrazů OCI.',
    imageHeadNotCached: 'není v cache — stáhne se při startu',
    imageNoRegistries: 'Není registrován žádný repozitář: zaregistruj jeden, aby šlo vybrat obraz.',
    imageChosenHint: 'Obraz se vybírá kaskádou v dialogu úprav: odkaz se nikdy nepíše ručně.',
    registerRepositoryHint: 'Registrace nic nestahuje: učiní repozitář sledovatelným, aby se obraz dal vybrat bez opuštění tohoto dialogu.',
    registerRepositoryBranchHint: 'Volitelné: první sledovaná větev (např. latest).',
    registerRepositoryElsewhere: 'Hledaný repozitář není registrován: registrace probíhá v sekci Obrazy OCI, provádí ji ten, kdo má oprávnění.'
  },

  // Šablony CT (round K2 #63): MATERIALIZOVANÉ objekty CT — import z katalogu
  // je jediný vstup; soubory se nahrávají do katalogů.
  cts: {
    createAction: 'Vytvořit CT',
    createTitle: 'Vytvořit kontejner ze šablony',
    createError: 'Kontejner nebyl vytvořen',
    template: 'Šablona CT',
    noTemplates: 'Žádná šablona CT — importujte nějakou v Šablonách CT',
    resources: 'Prostředky',
    node: 'Uzel',
    phase: {
      defined: 'Nikdy nespuštěn',
      materializing: 'Materializuje se',
      ready: 'Připraven',
      starting: 'Spouští se',
      running: 'Běží',
      stopping: 'Zastavuje se',
      stopped: 'Zastaven',
      deleting: 'Odstraňuje se',
      error: 'V chybě'
    },
    actions: {
      start: 'Spustit',
      stop: 'Zastavit',
      restart: 'Restartovat',
      markTemplate: 'Povýšit na šablonu CT',
      error: 'Akce byla odmítnuta'
    },
    markTemplate: {
      confirmTitle: "Povýšit '{name}' na šablonu CT?",
      confirmBody: 'Kontejner opustí tento seznam a přejde mezi Šablony CT, hned připraven generovat nové CT. Metadata zůstávají upravitelná a kdykoli ho můžete vrátit na CT.',
      confirm: 'Povýšit',
      moved: "'{name}' je teď šablona CT — najdete ho v Šablonách CT."
    },
    stopCause: {
      api: 'Zastaven TVirtem',
      'ct-exit': 'Kontejner skončil sám',
      'host-reboot': 'Zemřel s restartem uzlu',
      'start-failed': 'Spuštění selhalo — chyba úlohy říká, co chybí a jak to spravit'
    },

    console: 'Konzole',
    consoleUnavailable: 'Kontejner neběží — konzole potřebuje živý kontejner. Jeho logy se naproti tomu čtou v jakémkoli stavu.',
    consoleNoTemplate: 'Šablona nikdy neběží, takže nemá konzoli: vytvořte z ní CT a otevřete konzoli jeho.',
    consoleConnect: 'Připojit',
    consoleDisconnect: 'Odpojit',
    consoleReconnect: 'Znovu připojit',
    consoleTakenBy: 'Tuto konzoli převzal jiný operátor ({user}). Jedna konzole na kontejner: opětovné připojení ji vezme zpět.',
    consoleHint: 'Klikněte na černé pole a pište: klávesy dorazí do kontejneru. Ctrl+C a šipky fungují.',
    consoleEndpointDown: 'Přístupový bod konzole nelze otevřít na uzlu, který kontejner obsluhuje: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Kontejner neběží — shell potřebuje živý kontejner. Jeho logy lze číst v jakémkoli stavu.',
    shellNoTemplate: 'Template nikdy neběží, takže nemá shell: vytvořte z něj CT a otevřete jeho.',
    shellConnect: 'Připojit',
    shellDisconnect: 'Odpojit',
    shellExited: 'Relace skončila s návratovým kódem {code}.',
    shellEndedWithoutStatus: 'Relace skončila bez návratového stavu: {reason}',
    shellRevoked: 'Ticket relace už není platný — vypršel, nebo přihlášení, které ho otevřelo, bylo odvoláno.',
    shellHint: 'Klikněte do černého pole a pište: klávesy jdou do kontejneru. Ctrl+C a šipky fungují; exit shell zavře.',
    shellStatus: {
      connecting: 'Připojování…',
      connected: 'Připojeno',
      ended: 'Ukončena'
    },
    rootPassword: 'Heslo roota',
    rootPasswordHint: 'Zapíše se jednou do zkopírovaného rootfs (jako hash, už se nikdy nezobrazí). Obrazy distribucí nemají heslo roota: bez něj je shell jediná cesta dovnitř.',
    sshKeys: 'Veřejné SSH klíče roota',
    sshKeysHint: 'Jeden veřejný klíč OpenSSH na řádek, do root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Připojování…',
      connected: 'Připojeno',
      reconnecting: 'Opětovné připojování…'
    },
    logs: 'Logy',
    logsTitle: 'Logy',
    logsEmpty: 'Žádný zachycený výstup.',
    logsSource: 'Který log',
    logsSourceConsole: 'Konzole initu kontejneru — proč se služba uvnitř nespustila',
    logsSourceSupervisor: 'Supervizor liblxc — proč se kontejner nikdy nedostal až ke spuštění',
    logsNeverStarted: 'Nikdy nebyl spuštěn, takže zatím není nic zaznamenáno — spusťte ho a logy tam budou, i když spuštění selže.',
    logsNoTemplate: 'Šablona nikdy neběží, takže nikdy nic nezaznamenala.',
    logsError: 'Logy se nepodařilo zachytit',

    // Standardní dialog (round #156): karty detailu sdílené seznamy CT
    // a Šablony CT, plus zámky s vysvětlením proč.
    tabs: {
      general: 'Obecné',
      hardware: 'Hardware',
      network: 'Síť',
      provenance: 'Původ'
    },
    templateFlag: 'Šablona CT',
    templateLock: 'Mění se jen akcemi Povýšit / Vrátit na CT — nikdy přímou úpravou.',
    sourceLock: 'Původ, zaznamenaný při zrození — nikdy se nepřepisuje; mrtvý zdroj nechá holý odkaz.',
    storageLock: 'Zafixováno při vytvoření — přesun rootfs je budoucí round.',
    startedAt: 'Spuštěn',
    lastStop: 'Poslední zastavení',
    editNicsTitle: 'Upravit sítě',
    nicDisconnected: 'odpojená'
  },
  ctTemplates: {
    title: 'Šablony CT',
    importAction: 'Importovat z katalogu',
    importTitle: 'Importovat šablonu CT z katalogu',
    importSubmit: 'Importovat',
    importError: 'Import byl odmítnut',
    importHint: 'Materializace zkopíruje rootfs na zvolené úložiště — soubor v katalogu zůstane netknutý. Nové soubory nejdřív nahrajte do katalogu.',
    sourceFile: 'Soubor šablony CT',
    sourceFileHint: 'Soubory ct-rootfs zvoleného katalogu, jen ty připravené',
    noFiles: 'V tomto katalogu není žádný připravený soubor ct-rootfs — nahrajte nějaký ze stránky katalogu',
    source: 'Zdrojový soubor',
    rootfsStorage: 'Úložiště rootfs',
    rootfsStorageHint: "Kde žije rozbalený strom rootfs — úložiště s filesystemem a dostatkem volného místa pro velikost po rozbalení plus zhruba 1 GiB rezervy (jinak import selže).",
    resources: 'Prostředky',
    cores: 'vCPU',
    memoryMiB: 'Paměť (MiB)',
    cpuLimit: 'Limit CPU',
    cpuLimitHint: 'Ekvivalenty hostitelských jader (např. 1.5); prázdné = bez stropu',
    cpuUncapped: 'bez stropu',
    cpuWeight: 'Váha CPU',
    hostname: 'Hostname',
    hostnameHint: 'Prázdné = název CT',
    nameservers: 'Nameservery DNS',
    dnsHint: 'Oddělené čárkou; prázdné = zdědí ty od hostitele',
    searchDomains: 'Vyhledávací domény DNS',
    dnsInherited: 'Zděděno od hostitele',
    networks: 'Sítě',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'Materializuje se',
      ready: 'Připravena',
      deleting: 'Odstraňuje se',
      error: 'Chyba'
    },
    exportAction: 'Exportovat do katalogu',
    exportTitle: 'Exportovat do katalogu',
    exportSubmit: 'Exportovat',
    exportError: 'Export byl odmítnut',
    exportHint: 'Zabalí materializovaný rootfs do NOVÉHO souboru ct-rootfs ve zvoleném katalogu — šablona zůstane netknutá.',
    exportName: 'Název souboru',
    exportNameHint: 'Prázdné = <template>-export-<n>',
    markCt: {
      action: 'Vrátit na CT',
      confirmTitle: "Vrátit '{name}' na CT?",
      confirmBody: 'Šablona opustí tento seznam a vrátí se do seznamu CT, znovu spustitelná. Dokud ji znovu nepovýšíte, nelze z ní vytvářet CT.',
      confirm: 'Vrátit na CT',
      moved: "'{name}' je znovu CT — najdete ho v seznamu CT."
    }
  },

  // OCI vlna 1 (Annex Q — model tag-jako-branch): OCI tag je branch
  // (pohyblivý ukazatel), digest je commit; refresh = „git fetch",
  // pull = vyhodnoť TEĎ, stáhni TEN digest.
  oci: {
    registriesTitle: 'Registry OCI',
    imagesTitle: 'Obrazy OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generický',
    providerImmutableHint: 'Provider je po vytvoření neměnný — jiný provider znamená nový registr.',
    url: 'URL',
    urlHintPreset: 'Předvyplněno providerem — přepište jen kvůli mirrorům.',
    urlHintRequired: 'Povinné u generických registrů: základní adresa URL https://.',
    urlHintEcr: 'Povinné: endpointy ECR jsou na účet a region — žádný preset neexistuje.',
    credential: 'Přihlašovací údaje',
    credentialNone: 'Anonymní přístup',
    credentialHint: 'Položka keystoru typu uživatel-a-heslo; workery ji vyhodnocují až při použití — nikdy auth soubor na uzel.',
    nameHint: 'Název ve tvaru hostname (docker.io, registry.intra); jedinečný na scope, neměnný',
    addRegistry: 'Přidat registr',
    addRegistryTitle: 'Přidat registr OCI',
    verify: 'Ověřit',
    verifyState: 'Ověření',
    verified: 'Ověřeno',
    verifyFailed: 'Selhalo',
    neverVerified: 'Nikdy neověřeno',
    registryInUseError: "'{name}' má stále registrované repozitáře — nejdřív je odstraňte.",
    repositories: 'Repozitáře',
    repositoriesHint: 'Registrace sleduje branche (OCI tagy) — nic nestahuje. Refresh vyhodnotí každý sledovaný branch a udržuje reflog.',
    noRepositories: 'Na tomto registru není registrovaný žádný repozitář.',
    registerRepository: 'Registrovat repozitář',
    repoPath: 'Cesta',
    repoPathHint: "Cesta repozitáře na registru, např. 'example' nebo 'library/nginx'",
    branches: 'Branche',
    branchesHint: 'Sledované branche (OCI tagy), oddělené čárkou — např. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Vyhodnoceno TEĎ: pull stáhne digest, na který branch ukazuje dnes.',
    refresh: 'Aktualizovat',
    deleteRepository: 'Odstranit repozitář',
    reflogCount: 'předchozích: {n}',
    noResolutions: 'Nikdy neaktualizováno — žádné pozorované vyhodnocení.',
    refreshFailed: 'Poslední aktualizace selhala ({when})',
    loadError: 'Repozitáře se nepodařilo načíst.',
    reference: 'Odkaz',
    digest: 'Digest',
    digestHint: 'sha256:… — přesný obraz, bez branche (detached)',
    size: 'Velikost',
    nodes: 'Uzly',
    detached: 'detached',
    detachedHint: 'Stažen podle digestu, bez branche — kontrola driftu se neuplatní.',
    pulledAt: 'Stažen',
    pull: 'Pull',
    pullTitle: 'Pull obrazu',
    pullHint: 'Pre-warming, nikdy prerekvizita: pull podle branche vyhodnotí TEĎ a stáhne TEN digest; pull podle digestu je detached.',
    pullError: 'Pull byl odmítnut',
    pullMode: 'Pull podle',
    pullModeBranch: 'Branch (vyhodnotit teď)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Poctivý default: jako apt install — spuštěno později může dát jiný obraz.',
    pullModeDigestHint: 'Přesný digest — reprodukovatelnost a rollback; vzdává se kontroly driftu.',

    // Vzor dvou tlačítek (#88, ratifikace 2026-07-30 večer): „z registru" je
    // stávající vedený pull, „z katalogu" materializuje připravený archiv
    // oci-image (air-gapped cesta).
    importFromRegistry: 'Importovat z registru',
    importFromCatalog: 'Importovat z katalogu',
    importCatalogTitle: 'Importovat obraz OCI z katalogu',
    importCatalogHint: 'Air-gapped cesta: připravený archiv oci-image (tar/tar.gz — docker-archive nebo oci-archive) se materializuje do store obrazů s odkazem catalog/<catalogo>/<file>@<digest>; aplikace ho konzumují jako každý jiný obraz. Archivy se nahrávají do katalogů — tato sekce jen importuje.',
    importCatalogFile: 'Archiv',
    importCatalogFileHint: 'Připravené soubory oci-image zvoleného katalogu.',
    importCatalogNoFiles: 'V tomto katalogu není žádný připravený archiv oci-image — nahrajte nějaký z detailu katalogu.',
    importCatalogError: 'Import byl odmítnut',
    registry: 'Registr',
    repository: 'Repozitář',
    cacheMissing: 'Mezipaměť OCI klastru není nastavena — pully jsou odmítány, dokud nenastavíte pool úložiště.',
    setCache: 'Nastavit mezipaměť',
    setCacheTitle: 'Nastavit mezipaměť OCI',
    setCacheHint: 'DEFAULT pool na úrovni klastru, který hostí bloby stažených obrazů — scope může udělat override vlastním poolem (stránka Scope). Změna neproběhne za běhu, nic nerestartuje a bloby nepřesouvá: objeví se lazy při příštím startu/použití.',
    cachePool: 'Pool úložiště',
    changeCache: 'Změnit mezipaměť',
    changeCacheTitle: 'Změnit pool mezipaměti OCI',
    cacheCurrent: 'Mezipaměť OCI klastru (default): {name}',
    sectionOverview: 'Přehled',
    sectionRepositories: 'Repozitáře',
    sectionExplore: 'Prozkoumat',
    exploreHint: 'Živé vzdálené hledání na registru — Docker Hub plně (popis, stažení, hvězdy), ostatní provideři best-effort. Vyberte výsledek: přečtete si celý popis a projdete vzdálené tagy; z tagu můžete přidat odkaz do repozitáře TVirt.',
    exploreSearch: 'Hledat',
    exploreUnsupported: 'Tento provider hledání nepodporuje.',
    exploreNoResult: 'Žádný odpovídající repozitář.',
    exploreNoTags: 'Na tomto repozitáři žádný odpovídající tag.',
    exploreOfficial: 'Oficiální',
    explorePulls: 'Stažení',
    exploreStars: 'Hvězdy',
    exploreUpdated: 'Aktualizováno {when}',
    exploreLoadMore: 'Načíst další',
    exploreSelectHint: 'Vyberte výsledek: celý popis a vzdálené tagy se načtou sem.',
    exploreNoDescription: 'Od tohoto providera není k dispozici žádný popis.',
    exploreTagsTitle: 'Vzdálené tagy',
    exploreTagFilter: 'Hledat tag',
    exploreAddToRepo: 'Přidat do repozitáře',
    exploreAdded: '{path}:{tag} je nyní sledován — viz sekce Repozitáře.',
    addBranch: 'Přidat branch',
    purgeRequiredTitle: "Odstranit '{name}' a jeho obrazy?",
    purgeRequiredBody: 'Tento repozitář nekonzumuje žádná aplikace, ale stále existují stažené obrazy: jeho odstraněním se odstraní i jejich záznamy a bloby v mezipaměti připadnou garbage collectoru.',
    purgeConfirm: 'Odstranit i obrazy',
    providerSelectHint: 'Vyberte typ registru: karta popisuje preset a použití.',
    providerDesc: {
      dockerhub: 'Veřejný registr Dockeru: předvyplněná URL, plné hledání s popisy a počty.',
      ghcr: 'GitHub Container Registry: předvyplněná URL; účty používají personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointy na účet a region — URL je nutné zadat.',
      quay: 'Registr Red Hat Quay: předvyplněná URL.',
      generic: 'Self-hosted registr (Harbor, registry:2, …): adresa URL https:// je povinná.'
    },

    // Standardní dialog (round #156): pole detailu obrazu/registru,
    // která sloupce neukazovaly.
    layerCount: 'Vrstvy',
    verifiedAt: 'Poslední ověření',
    verifyOk: 'Výsledek',
    verifyMessage: 'Zpráva ověření',

    // Model #348/R39: obraz JE digest — obsah — a registry, repozitář a větev jsou JMÉNA, která k němu vedou.
    head: 'Head',
    heads: 'Hlavy podle architektury',
    listDigest: 'Digest seznamu',
    neverResolved: 'Nikdy nevyhodnocen',
    totalSize: 'Celková velikost',
    reflogTitle: 'Historie vyhodnocení',
    usedBy: 'Používá',
    usageLockfile: 'lockfile',
    usageRunning: 'běží',
    evictable: 'vyřaditelný',
    evict: 'Vyřadit z mezipaměti',
    evictHeadTitle: 'Vyřadit {digest}?',
    evictHeadBody: 'Je to aktuální vyhodnocení nejméně jednoho kolektoru: vyřadit ho je legitimní — je to jen mezipaměť, vzdálený branch ho stále poskytuje — ale nesmí se to stát omylem. Blob je JEDEN: vyřazení vyprázdní všechny kolektory, které ho sdílejí.',
    evictConfirm: 'Přesto vyřadit',

    arch: 'Architektura',
    names: 'Jména',
    noNames: 'bez jména',
    views: 'Pohledy',
    lastView: 'poslední pohled',
    evictLastViewTitle: 'Odebrat poslední odkaz na {digest}?',
    evictLastViewBody: 'Toto je poslední pohled na tento obsah: jeho odebráním obraz přestane v TVirt existovat a bajty ({size}) se uvolní. Je to docker image rm tohoto modelu — ne vedlejší efekt, ale sama operace.',
    branchesTabHint: 'Sledované větve tohoto repozitáře: u každé dnešní hlavy — jedna na architekturu — chronologie obnovení a kolik jí pojmenovaných obrazů je v cache. Obnovení je «git fetch» repozitáře: vyřeší všechny jeho větve naráz.',
    noBranches: 'V tomto repozitáři není sledována žádná větev.',
    stopObserving: 'Přestat sledovat větev',
    pullBranch: 'Stáhnout do cache hlavu branche (refresh rozliší, tohle stahuje)',
    pullDigest: 'Stáhnout do cache tento digest',
    imageCount: 'Obrazy',
    deleteBranchPurgeTitle: 'Ponechat obrazy {name} bez jména?',
    deleteBranchPurgeBody: 'Žádná aplikace tuto větev nejmenuje, ale některé obrazy jsou dosažitelné jen přes ni: po jejím smazání zůstanou v cache bez jména, vypsané mezi obrazy repozitáře a odstranitelné ručně.',
    deleteBranchPurgeConfirm: 'Smazat a ponechat obrazy bez jména',
    imagesTabHint: 'Obrazy tohoto repozitáře — obsah, tedy digesty — viditelné i bez výběru větve. Obraz je v rámci clusteru jedinečný: jmen, která k němu vedou, může být více.',
    noImages: 'Žádný obraz tohoto repozitáře není v cache materializován.',
    deleteRepositoryTitle: 'Smazat {name}?',
    deleteRepositoryBody: 'Repozitář a jeho větve zmizí i s chronologií. Obrazy zůstanou v cache: ztratí jen toto jméno. Repozitář, který jmenuje aplikace, smazat nelze.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Obnoveno',
    neverRefreshed: 'Nikdy neobnoveno',
    sectionBranches: 'Větve',
    sectionImages: 'Obrazy',
    repositoriesGovernedElsewhere: 'Zde se repozitáře pouze prohlížejí: registrace, obnovení, sledování větví a odstraňování obrazů se dělá v sekci Obrazy OCI.',
    gotoImages: 'Přejít na Obrazy OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pody',
    containers: 'Kontejnery',
    instances: 'Instance',
    instancesTooltip: '{running} běží, {error} v chybě',
    placement: 'Umístění',
    spread: 'rozložení',
    ha: 'HA',
    templateRevision: 'revize',
    deleting: 'Odstraňuje se',
    empty: 'Žádné pody — vytvořte aplikaci (jeden kontejner) nebo pod z CLI (create-pod).',
    openInstances: 'Otevřít instance',
    rollingRestart: 'Postupný restart',
    scale: 'Škálovat',
    scaleTitle: 'Škálovat {name}',
    scaleHint: 'Počet instancí (0–64): nahoru se obsadí nejnižší volné pořadové číslo, dolů se odebere nejvyšší a jeho trvalá data zůstanou.',
    scaleError: 'Škálování se nezdařilo',
    replicas: 'Repliky',
    deleteRunningError: '{name} běží — nejprve jej zastavte.',
    deleteInstancesIntro: 'Všech {count} instancí bude odstraněno.',
    stateRunning: 'Běží',
    stateStopped: 'Zastaven',
    editor: {
      createTitle: 'Vytvořit Pod',
      create: 'Vytvořit Pod',
      editTitle: 'Upravit Pod',
      nameHint: 'DNS-1123, nejvýše 58 znaků — instance se jmenují <název>-<index>; po vytvoření neměnné.',
      restartPolicy: 'Politika restartu',
      restartPolicyHint_always: 'Uzel restartuje každý ukončený kontejner s exponenciálním backoffem (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Restartuje se jen kontejner ukončený nenulovým kódem; výstup 0 zůstává v klidu.',
      restartPolicyHint_never: 'Ukončený kontejner zůstane, jak je — instance skončí jako succeeded nebo failed.',
      grace: 'Odklad (s)',
      graceHint: 'Mez SIGTERM → SIGKILL zastavení.',
      hostname: 'Hostname',
      hostnameHint: 'Prázdné = název instance.',
      hostnameDefault: 'název instance',
      sharePid: 'Sdílet jmenný prostor PID mezi kontejnery',
      containersIntro: 'Init kontejnery běží do konce, popořadě, než se spustí kontejnery; kontejnery sdílejí síť instance (jedna IP, localhost mezi nimi).',
      initContainers: 'Init kontejnery',
      initAdd: 'Přidat init kontejner',
      initHint: 'Každý musí skončit s 0; selhání uvede instanci do chyby a uzel jej zopakuje s backoffem.',
      containerAdd: 'Přidat kontejner',
      atLeastOne: 'Pod potřebuje alespoň jeden kontejner.',
      duplicateNames: 'Názvy kontejnerů musí být v Podu jedinečné (včetně init kontejnerů).',
      containerName: 'Název kontejneru',
      containerInvalid: 'Tento kontejner je neúplný: název (DNS-1123), image, připojení na deklarované svazky, číselné limity a sonda.',
      command: 'Příkaz',
      commandHint: 'Přepíše entrypoint image — jeden argument na řádek, nikdy řetězec shellu.',
      args: 'Argumenty',
      argsHint: 'Jeden na řádek (CMD image, je-li prázdné).',
      mounts: 'Připojení',
      mountAdd: 'Přidat připojení',
      mountNoVolumes: 'Nejprve deklarujte svazek na kartě Úložiště.',
      readOnly: 'jen pro čtení',
      resources: 'Limity',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (např. 1.5)',
      memory: 'Paměť (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda živosti',
      healthCmd: 'Příkaz sondy',
      healthCmdHint: 'Spouští uzel v kontejneru při každém tiku dohledu — jeden argument na řádek; výstup 0 = zdravý.',
      healthTimeout: 'Časový limit (s)',
      healthRetries: 'Pokusy',
      healthRetriesHint: 'Po sobě jdoucí selhání, než uzel kontejner restartuje.',
      ips: 'Statické adresy',
      ipsHint: 'Jedna na instanci, v pořadí ordinálů — škálování nad seznam je odmítnuto.',
      instance: 'instance',
      volumesHint: 'Svazky jsou Podu; cesta připojení patří každému kontejneru (karta Kontejnery).',
      spread: 'Rozložení',
      spreadHint_preferred: 'Instance na různých uzlech, je-li to možné.',
      spreadHint_required: 'Instance na různých uzlech, jinak škálování odmítne.',
      spreadHint_none: 'Jen rozhodovač.',
      ha: 'Vysoká dostupnost (opt-in)',
      haHint: 'Každá trvalá část na sdíleném úložišti; pokud uzel zemře, HA decider znovu vytvoří instance na jiném členovi (automatický failover, jako u HA VM).',
      yes: 'ano',
      no: 'ne'
    },
    detail: {
      container: 'Kontejner',
      actions: 'Akce',
      ready: 'Připraven',
      notReady: 'Nepřipraven',
      restarts: 'Restarty',
      lastRestartAt: 'Poslední restart:',
      backoffUntil: 'Další pokus v',
      stateAbsent: 'chybí',
      stateRunning: 'běží',
      stateTerminated: 'ukončen',
      stateWaiting: 'čeká',
      init: 'init',
      noInstances: 'Žádné instance (repliky 0).',
      ha: 'HA',
      haHint: 'Automatický failover: pokud uzel zemře, HA decider znovu vytvoří instanci na jiném členovi (každá trvalá část na sdíleném úložišti).',
      authority: 'Authority (uzel)',
      homeless: 'bez authority',
      homelessHint: 'Obnova z checkpointu vynechá authority (#380): žádný uzel ji neobsluhuje, dokud Pod neškálujete (stačí i na stejný počet replik).',
      restartContainer: 'Restartovat jen tento kontejner (pod zůstává nahoře)',
      divergingHint: 'Požadovaný stav této instance se liší od výchozího stavu Podu (PD-P19).',
      revisionLag: 'revize {applied} použita z {current}',
      updatedInstances: '{updated}/{desired} instancí na této revizi'
    }
  }
}
